import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'eoc.heartbeats.delete-modal.title.no-translate',
		defaultMessage: 'Delete heartbeat?',
		description: 'The text will be displayed in the delete modal title',
	},
	description: {
		id: 'eoc.heartbeats.delete-modal.description.no-translate',
		defaultMessage:
			'This will permanently delete the heartbeat, and we’ll not send alerts when this heartbeat becomes unresponsive',
		description: 'The text will be displayed in the delete modal body description',
	},
	warning: {
		id: 'eoc.heartbeats.delete-modal.warning.no-translate',
		defaultMessage: 'If you’re not sure, you can turn off the heartbeat instead.',
		description: 'The text will be displayed in the delete modal body description for warning',
	},
	cancel: {
		id: 'eoc.heartbeats.delete-modal.cancel-button.no-translate',
		defaultMessage: 'Cancel',
		description: 'The text will be displayed in the delete modal footer for cancel button.',
	},
	delete: {
		id: 'eoc.heartbeats.extra-property.delete-modal.delete-button.no-translate',
		defaultMessage: 'Delete',
		description: 'The text will be displayed in the delete modal footer for delete button.',
	},
});
